import * as React from 'react'

import moment from 'moment'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { useGetAttendanceBreakConfigurationsRange } from 'modules/attendance/hooks/useGetAttendanceBreakConfigurationsRange'
import { AttendanceBreaksProvider } from 'modules/attendance/lib/attendanceBreaksContext'
import { useAttendanceDateNavigator } from 'modules/attendance/lib/attendanceDateNavigatorContext'
import { BlockAutoScrollProvider } from 'modules/attendance/lib/blockAutoScrollContext'
import { TimesheetDataProvider } from 'modules/attendance/lib/timesheetDataContext'
import { useGetBreakConfigurations } from 'modules/time_categories_settings/hooks/useGetBreakConfigurations'

import WeeklyViewBody from './WeeklyView/WeeklyViewBody'

interface Props {
  employeeId: number
  attendanceEmployeesPolicyId: number | null | undefined
  showHourBalance: boolean
  isDaily: boolean
  isPartTime?: boolean
}

const AdminLayout = ({
  children,
  employeeId,
  attendanceEmployeesPolicyId,
  showHourBalance,
  isDaily,
  isPartTime = false,
}: React.PropsWithChildren<Props>) => {
  const [timesheetLoading, setTimesheetLoading] = React.useState(false)
  const [blockAutoScroll, setBlockAutoScroll] = React.useState(false)

  const { company } = useCurrentSession()
  const { stringDateFrom: startOn, stringDateTo: endOn } = useAttendanceDateNavigator()

  const { loading: loadingAttendanceBreaks, breakConfigurationsRange: attendanceBreaks } =
    useGetAttendanceBreakConfigurationsRange(attendanceEmployeesPolicyId, startOn, endOn)
  const { loading: loadingAllBreaks, breakConfigurations: allBreaks } = useGetBreakConfigurations(
    {}
  )

  const today = moment()
  const todayBreaks = attendanceBreaks.get(today.format('YYYY-MM-DD')) ?? []
  const loadingBreaks = loadingAttendanceBreaks || loadingAllBreaks || timesheetLoading

  const handleSetBlockAutoScroll = (newBlockAutoScroll: boolean) => {
    setBlockAutoScroll(newBlockAutoScroll)
  }

  return (
    <AttendanceBreaksProvider
      value={{
        allBreaks,
        attendanceBreaks,
        todayBreaks,
        loadingBreaks,
      }}
    >
      <TimesheetDataProvider
        employeeId={employeeId}
        companyId={company.id}
        setLoading={setTimesheetLoading}
        isPartTime={isPartTime}
      >
        <BlockAutoScrollProvider
          value={{ blockAutoScroll, setBlockAutoScroll: handleSetBlockAutoScroll }}
        >
          <WeeklyViewBody
            employeeId={employeeId}
            showHourBalance={showHourBalance}
            isDaily={isDaily}
          >
            {children}
          </WeeklyViewBody>
        </BlockAutoScrollProvider>
      </TimesheetDataProvider>
    </AttendanceBreaksProvider>
  )
}

export default AdminLayout
